import { render, staticRenderFns } from "./infoBlock.vue?vue&type=template&id=5d523445&scoped=true&"
import script from "./infoBlock.vue?vue&type=script&lang=js&"
export * from "./infoBlock.vue?vue&type=script&lang=js&"
import style0 from "./infoBlock.vue?vue&type=style&index=0&id=5d523445&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d523445",
  null
  
)

export default component.exports